<script lang="ts" setup>
import { computed, ref, useAttrs, watch } from 'vue'
import { useEventListener } from '@vueuse/core'
import DTTooltip from './DTTooltip.vue'

const props = defineProps<{
  target: HTMLElement
  options: object
}>()

const tooltip = ref<InstanceType<typeof DTTooltip>>()

watch([tooltip, () => props.target], ([tooltip, target]) => {
  if (target && tooltip) {
    Object.keys(tooltip?.triggers).forEach((trigger) => {
      // @ts-expect-error object keys not good
      useEventListener(target, trigger, tooltip?.triggers[trigger])
    })
  }
}, { immediate: true })

const boundAttrs = computed(() => ({
  ...useAttrs(),
  ...props.options,
}))
</script>

<template>
  <DTTooltip
    ref="tooltip"
    v-bind="boundAttrs"
    :target
    class="!block"
  />
</template>
